export default "<div class=\"map flex\" id=\"map-canvas\"></div>\n"